import { render, staticRenderFns } from "./ControlModelShape.vue?vue&type=template&id=2c7f57b0&scoped=true"
import script from "./ControlModelShape.vue?vue&type=script&lang=js"
export * from "./ControlModelShape.vue?vue&type=script&lang=js"
import style0 from "./ControlModelShape.vue?vue&type=style&index=0&id=2c7f57b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7f57b0",
  null
  
)

export default component.exports